import { useEffect } from 'react';

/**
 * 모달/라이트박스 열렸을 때 html, body 의 스크롤을 잠그는 공통 훅.
 * - 모든 모달 컴포넌트는 이 훅을 사용해 통일된 동작을 보장
 * - 직접 `document.body.style.overflow` 조작은 금지
 */
export function useScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return;
    const body = document.body;
    const html = document.documentElement;
    const prevBody = body.style.overflow;
    const prevHtml = html.style.overflow;
    body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';
    return () => {
      body.style.overflow = prevBody;
      html.style.overflow = prevHtml;
    };
  }, [isLocked]);
}
